import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	lastModified: {
		id: 'search-result.last-modified',
		defaultMessage: 'Updated {formattedDate}',
		description: 'This shows the timestamp of when the result was last modified.',
	},
});
